var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudent2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "105mm",
    height: "74mm",
    viewBox: "0 0 105 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M344.563 835.801s-72.145-11.332-63.215-44.531c13.871-51.622 56.75-40.348 119.582-17.379 53.34 19.488-56.367 61.91-56.367 61.91M840.824 961.09l-55.164 11.961 21.781 100.699 55.172-11.93-21.789-100.73",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.859 965.801c8.614 0 20.579.308 33.125.961l5.36 30.367H785.66l-5.215-29.57c8.832-1.129 19.594-1.758 31.414-1.758",
    style: {
      fill: "#f14950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m850.344 997.129-5.36-30.367L809.82 767.32c44.852 6.782 88.926 26.981 129.004 57.481l28.793 163.211-117.273 9.117m-64.684 0-120.449-9.117-28.793-163.211c29.383-30.5 66.332-50.699 108.742-57.481l35.285 200.239 5.215 29.57",
    style: {
      fill: "#515067",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.859 601.391H597.035l54.641 309.82H770.52l-54.661-309.82m64.715 0h118.879l54.625 309.82H835.203l-54.629-309.82",
    style: {
      fill: "#515067",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.859 965.801c-11.82 0-22.582.629-31.414 1.758l-3.558-20.2L745.16 767.32l-29.301-165.929h64.715L809.82 767.32l31.762 180.039 3.402 19.403c-12.546-.653-24.511-.961-33.125-.961",
    style: {
      fill: "#e9e9e9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.09 501.449H613.188v102.242H892.09V501.449",
    style: {
      fill: "#a52127",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.387 252.09h-49.383v393.98h49.383V252.09m754.063 0h49.39v393.98h-49.39V252.09",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.91 586.898H329.578v83.942h805.332v-83.942",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.84 613.691H312.004v81.911h852.836v-81.911",
    style: {
      fill: "#9d7d61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.363 622.832H615.051v54.449h267.312v-54.449",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.203 567.68c-29.387 14.961-65.367 3.019-80.316-26.66L487.641 298.73l124.023-16.718 107.609 204.859c15.004 29.688 3.29 65.859-26.07 80.809m199.176-46.02c.914 33.238-25.066 60.942-57.969 61.871-32.93.899-60.418-25.351-61.351-58.59l-5.879-225.449 120.636-11.152 4.563 233.32",
    style: {
      fill: "#f14950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.734 298.73c-4.707 11.801-98.894 17.68-119.488 3.442-6.555-4.492-10.199-34.32-10.199-34.32h135.676s-2.278 21.519-5.989 30.878",
    style: {
      fill: "#5d524e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.723 252.09H759.047v15.762h135.676V252.09",
    style: {
      fill: "#2f2927",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.641 298.73c4.707 11.801 98.964 17.68 119.507 3.442 6.54-4.492 10.297-34.32 10.297-34.32H481.719s2.23 21.519 5.922 30.878",
    style: {
      fill: "#5d524e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.719 252.09h135.726v15.762H481.719V252.09",
    style: {
      fill: "#2f2927",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.371 1337.48s-220.351-118.83-122.863-235.47c69.41-83.22 291.566 113.11 291.566 113.11l-168.703 122.36m96.684-46.52s112.199-9.96 150.582-34.81c0 0 10.789 114.12-21.699 151.25-15.274 17.52-70.59 28.15-131.465 27.07l2.582-143.51",
    style: {
      fill: "#f14950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.055 1290.96s-117.325-7.66-154.789-33.87c0 0-5.387 102.4 25.672 140.72 14.617 18.07 65.527 35.55 126.535 36.66l2.582-143.51",
    style: {
      fill: "#f14950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.83 1153.61c1.43-78.14-71.392-142.75-162.592-144.39-91.254-1.68-166.355 60.31-167.773 138.48-1.406 78.04 71.39 142.65 162.668 144.31 91.203 1.64 166.277-60.31 167.697-138.4",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.383 1168.75c.164-9.26-7.211-16.9-16.43-17.07-9.262-.18-16.875 7.23-17.047 16.47-.16 9.17 7.223 16.89 16.438 17.03 9.215.17 16.898-7.23 17.039-16.43",
    style: {
      fill: "#414042",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.305 1172.6c.082-3.85-2.922-7.03-6.754-7.09a6.944 6.944 0 0 0-7.051 6.83c-.07 3.81 2.969 6.98 6.793 7.06a6.886 6.886 0 0 0 7.012-6.8",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.367 1164.16c.168-9.26 7.805-16.6 16.973-16.44 9.211.15 16.64 7.79 16.476 17.05-.164 9.2-7.878 16.62-17.089 16.46-9.141-.2-16.532-7.85-16.36-17.07",
    style: {
      fill: "#414042",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.242 1168.32c.067-3.87 3.227-6.93 7.055-6.84 3.781.04 6.883 3.25 6.812 7.07-.078 3.81-3.289 6.9-7.046 6.8-3.86-.06-6.918-3.24-6.821-7.03",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.301 1141.97c.207-11.37-11.121-20.8-25.317-21.05-14.125-.27-25.785 8.77-26 20.13-.179 11.37 11.125 20.79 25.274 21.04 14.172.25 25.812-8.77 26.043-20.12",
    style: {
      fill: "#fdb5ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.32 1119.32c.235-12.5-9.73-22.84-22.215-23.07-12.414-.22-22.8 9.78-23.007 22.25-.243 12.48 9.773 22.77 22.183 23 12.489.24 22.805-9.7 23.039-22.18m267.758 4.82c.211-12.52 10.508-22.48 22.965-22.24 12.507.21 22.497 10.56 22.287 23.04-.23 12.5-10.63 22.44-23.107 22.21-12.457-.22-22.379-10.53-22.145-23.01",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.465 1149.55s-31.121 89.43-2.774 153.09c28.473 63.75 56.629 44.21 70.805 84.55 0 0 18.078-35.14 7.551-52.25 0 0 87.937 80.18 181.297 32.52 0 0-87.699-7.71-95.051-29.45 0 0 176.527 44.22 197.467-96.16 0 0-53.358 53.29-82.694 58.19 0 0 77.274-11.23 53.524-154.75 0 0-18.543 81.98-34.34 92.58-18.187 12.31-26.727 2.31-76.797 1.43-54.109-1-68.914 14-71.316 17.79-2.375 3.81-23.934-84.65-147.672-107.54",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m901 802.07 55.785 183.258 139.475 28.092-41.67 86.93 105.02 1.08 43.12-135.629L901 802.07",
    style: {
      fill: "#515067",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.59 1100.35s-51.8 73.44-14.2 84.83c37.62 11.36 106.42-56.8 109.17-86.43l-94.97 1.6",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.211 988.012S322.652 841.09 322.066 831.871c-.597-9.211 50.606-77.301 50.606-77.301l311.113 127.66-18.574 105.782",
    style: {
      fill: "#515067",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.895 1049.43c43.769-2.63 63.769 35.28 65.89 70.34l-123.012 7.2c-2.019-35 15.231-75.06 57.122-77.54",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.281 1127.23c.114-6.29-6.16-11.53-14.015-11.64-7.825-.16-14.289 4.82-14.407 11.13-.089 6.29 6.153 11.52 14.008 11.66 7.856.14 14.293-4.86 14.414-11.15",
    style: {
      fill: "#fdb5ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06258 0 0 -.06258 6.086 89.776)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent2);
export default __webpack_public_path__ + "static/media/student2.61f9068fcf702f37187fe6d5b78161b3.svg";
export { ForwardRef as ReactComponent };